module.exports = __webpack_public_path__ + "static/media/scoli-shoulder-3f.69948e5b.png";